import React, { Component } from "react";
import { truncate } from 'lodash';
import { connect } from "react-redux";
import { Avatar, Popover } from "antd";
import IntlMessages from "util/IntlMessages";
import { logOut } from "util/Common";
import { Link } from "react-router-dom";
// import { getCookieValue, setCookieValue } from 'src/util/Common';

class UserInfo extends Component {

  // componentDidMount() {
  //   if (!getCookieValue('refresh')) {
  //     setCookieValue('refresh', true);
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 1000);
  //   }
  // }

  render() {
    const userMenuOptions = (
      <ul className="gx-user-popover">
        <li>
          <Link to={{ pathname: '/user/ho-so' }}>
            <IntlMessages id="app.userAuth.myAccount" />
          </Link>
        </li>
        <li onClick={() => logOut()}><IntlMessages id="app.userAuth.logOut" /></li>
      </ul>
    );
    const { userInfo, isDesktop } = this.props;
    const user = userInfo ? userInfo.user : {};
    return (
      <div className="gx-flex-row gx-align-items-center gx-avatar-row">
        <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
          {isDesktop &&
            <Avatar src={user ? user.avatar : 'https://via.placeholder.com/150x150'}
              className="gx-size-40 gx-pointer gx-mr-3" alt="" />
          }
          <span className="gx-avatar-name">{user ? truncate(user.hoVaTen, { 'length': 18, 'separator': ' ' }) : 'No name'}<i
            className="icon icon-chevron-down gx-fs-xxs gx-ml-2" /></span>
        </Popover>
      </div>
    )
  }
}
export default connect(null, {})(UserInfo);
